import { ReactElement } from 'react'
import { Alert, Box } from '@mui/material'
import { useEditorViewStore } from '@editorStores'
import PlanViewSceneOverlay from '../PlanViewSceneOverlay'

/**
 * Covers the scene while "Lastplan" is chosen as Plantyp: there is no preview for it yet.
 * Rendered by `PlanPdfPreview` on the "Planansicht" tab.
 */
const PlanViewLoadPlanNotice = (): ReactElement | null => {
  const planChoice = useEditorViewStore(state => state.planView.planChoice)

  if (planChoice !== 'loadPlan') return null

  return (
    <PlanViewSceneOverlay data-cy="plan-view-load-plan-notice">
      <Box sx={{ m: 'auto', px: 2, maxWidth: 480 }}>
        <Alert severity="warning">
          Für den Lastplan gibt es noch keine Vorschau. Über „Plan generieren“ kann er trotzdem
          erstellt werden.
        </Alert>
      </Box>
    </PlanViewSceneOverlay>
  )
}

export default PlanViewLoadPlanNotice
